import React, { useEffect, useState } from "react";
import { session_id_beg, session_id_end } from "../../../../../utils/helpers";
import CopyComponent from "../../../../../components/copyComponent";

var avatarPalettes = [
  { background: '#f5e6d8', color: '#b87040' },
  { background: '#faf0e8', color: '#c07838' },
  { background: '#eeddd0', color: '#a86030' },
  { background: '#f7ece0', color: '#d5a67b' },
  { background: '#f0e0cc', color: '#b87848' },
];
function getInitials(name) {
  if (!name) return '?';
  var parts = name.trim().split(' ').filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.substring(0, 2).toUpperCase();
}
function getAvatarStyle(name) {
  var idx = name ? name.charCodeAt(0) % avatarPalettes.length : 0;
  return Object.assign({}, avatarPalettes[idx], {
    width: 54, height: 54, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: '700', fontSize: '18px', flexShrink: 0,
  });
}

export default function WorkerBox({
  noShowActive,
  list = [],
  noShowRequest,
  noshowRemoveGroupAppointment,
  noshowFrom
}) {
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    console.log(list, "list");
  }, [list]);

  const filteredList = list.filter(item =>
    item.client &&
    item.client.screen_name &&
    item.client.screen_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="register-medium">
      <div
        className="modal fade"
        id="WorkerBox"
        role="dialog"
      >
        <div className="width-unset modal-dialog advanceConfirmbooking modal-lg modal-dialog-preview height-unset">
          <div className="modal-content p-5">
            <div className="modal-body">
              <div className="schedule-popup">
                <h3 className="mb-4 mt-2 text-center">
                  Workers For{" "}
                  {noShowActive !== undefined &&
                    `${session_id_beg}${noShowActive.id}${session_id_end}`}
                </h3>

                {/* 🔍 Search Input */}
                <input
                  type="text"
                  className="mb-4 mt-2 text-center attendees-search-input"
                  placeholder="Search name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />

                <div className="now-show-box-wrapper">
                  
                  {filteredList.length > 0 ? (
                    filteredList.map((item, index) => (
                      <div
                        key={index}
                        className={`profilecard-wrapper justify-content-between pointer w-90`}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <div className="profile-photo" style={{ flexShrink: 0, width: 54, height: 54, borderRadius: '50%', overflow: 'hidden' }}>
                            {item.client.profile_image ? (
                              <img
                                width="100%"
                                height="100%"
                                style={{ objectFit: 'cover', display: 'block' }}
                                src={`${process.env.REACT_APP_IMAGE_URL}${item.client.profile_image}`}
                                alt="Profile"
                              />
                            ) : (
                              <div style={getAvatarStyle(item.client.screen_name)}>
                                {getInitials(item.client.screen_name)}
                              </div>
                            )}
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.4', textAlign: 'left' }}>
                            <span style={{ fontSize: '16px', fontWeight: '600', color: '#485257' }}>{item.client.screen_name}</span>
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '13px', color: '#888', marginTop: '2px' }}>
                              {item.client.email}
                              <CopyComponent value={item.client.email} />
                            </span>
                          </div>
                        </div>
                        <div>
                          {item.status === 0 || item.status === 1 ? (
                            <>
                              {noshowFrom === "remove" && (
                                <div
                                  className="margin-unset register-medium-confirnation appointment-no-show-card"
                                  onClick={() =>
                                    noshowRemoveGroupAppointment(item)
                                  }
                                  data-dismiss="modal"
                                >
                                  Remove
                                </div>
                              )}
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <div
                                className="margin-unset register-medium-confirnation appointment-no-show-card"
                                onClick={() => noShowRequest(item)}
                                data-dismiss="modal"
                              >
                                No Show
                              </div>
                            </>
                          ) : (
                            <span>
                              <b>
                                {item.status === 2
                                  ? `No Show by ${item.userbyName} at ${item.userbyDate}`
                                  : item.status === 3
                                  ? `Removed by ${item.userbyName} at ${item.userbyDate}`
                                  : ""}
                              </b>
                            </span>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No matching attendees found.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
